<template>
    <div>
        <b-modal ref="modal-company-assessment-member" size="xl" :title="`${company_request_project_code} - 평가 참여자 관리`"
                 body-class="bg-white"
                 :no-close-on-backdrop="is_opend_request_access_modal || is_editing_request_role || is_editing_request_access || is_participating_assessment || is_adding_participatent_searched_users"
                 :no-close-on-esc="is_opend_request_access_modal || is_editing_request_role || is_editing_request_access || is_participating_assessment || is_adding_participatent_searched_users"
                 hide-footer
                 centered
                 @hidden="initializeCompanyAssessmentMember"
        >

            <b-row>
                <b-col cols="12">
                    <div class="d-flex align-items-center">
                        <h5>평가 참여자</h5>
                        <fa icon="question-circle" class="ml-2" style="margin-top: -5px" @click="openHelpModal"></fa>
                    </div>

                    <b-table :items="company_request_member"
                             :fields="companyRequestMemberColumn"
                             bordered
                    >
                        <template #cell(project_code)="data">
                            <template v-if="data.value">
                                {{ data.value }}
                                <div>
                                    ({{ data.item.campaign_name }})
                                    <b-badge class="ml-1">{{ data.item.campaign_id }}</b-badge>
                                </div>
                            </template>
                            <template v-else> - </template>
                        </template>


                        <template #cell(user_company_name)="data">
                            <div :class="[{ 'border-bottom mb-1 pb-1': data.item.company_id !== data.item.request_company_id }]">
                                {{ data.value }}
                                <b-badge>{{ data.item.company_id }}</b-badge>
                            </div>
                            <template v-if="data.item.company_id !== data.item.request_company_id">
                                <div>
                                    {{ data.item.request_company_name }}
                                    <b-badge>{{ data.item.request_company_id }}</b-badge>
                                </div>
                            </template>
                        </template>

                        <template #cell(e_mail)="data">
                            {{ data.value }}
                            <div>
                                ({{ data.item.user_name }})
                                <b-badge>{{ data.item.user_id }}</b-badge>
                            </div>
                        </template>

                        <template #cell(request_company_name)="data">
                            <template v-if="data.value">
                                {{ data.value }}
                                <b-badge>{{ data.item.request_company_id }}</b-badge>
                            </template>
                            <template v-else>
                                <span class="gray-500">(미참여중)</span>
                            </template>
                        </template>

                        <template #cell(role)="data">
                            <template v-if="request_role[data.value]">
                                <b-badge class="f-80 font-weight-normal" :variant="request_role_variant[data.value]">
                                    {{ request_role[data.value] }}
                                </b-badge>
                            </template>
                            <template v-else>
                                <span class="gray-500">(미참여중)</span>
                            </template>
                        </template>

                        <template #cell(access_status)="data">
                            <template v-if="request_access[data.value]">
                                <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[data.value]">
                                    {{ request_access[data.value] }}
                                </b-badge>
                            </template>
                            <template v-else>
                                <span class="gray-500">(미참여중)</span>
                            </template>
                        </template>

                        <template #cell(managing)="data">
                            <template v-if="!request_role[data.item.role] && !request_access[data.item.access_status]">
                                <b-btn class="f-80" :disabled="is_participating_assessment"
                                       @click="participateAssessment(data.item)"
                                >
                                    평가 참여시키기
                                    <b-spinner v-show="is_participating_assessment && data.item.user_id === participating_assessment_user_id"></b-spinner>
                                </b-btn>
                            </template>
                            <template v-else>
                                <b-dropdown text="관리하기" size="sm" variant="primary" menu-class="py-0"
                                            :disabled="data.item.role === 2"
                                >
                                    <template v-if="data.item.role !== 2 || data.item.access_status !== 0">
                                        <b-dropdown-item-btn
                                            :disabled="is_editing_request_role || data.item.access_status !== 0 || data.item.role === 2"
                                            @click="managingManagerRole(data.item, data.index)"
                                        >
                                            관리자 지정
                                            <b-spinner v-show="is_editing_request_role && data.item.user_id === editing_request_role_user_id"></b-spinner>
                                        </b-dropdown-item-btn>
                                    </template>

                                    <b-dropdown-item-btn
                                        :disabled="is_editing_request_access"
                                        @click="managingAccess(data.item, data.index)"
                                    >
                                        참여상태 변경
                                        <b-spinner v-show="is_editing_request_access && data.item.user_id === editing_request_access_user_id"></b-spinner>
                                    </b-dropdown-item-btn>

                                    <template v-if="data.item.access_status > 0">
                                        <b-dropdown-item-btn
                                            :disabled="is_editing_request_access"
                                            @click="deleteAssessmentMember(data.item, data.index)"
                                        >
                                            평가 제외
                                            <b-spinner v-show="is_editing_request_access && data.item.user_id === editing_request_access_user_id"></b-spinner>
                                        </b-dropdown-item-btn>
                                    </template>
                                </b-dropdown>
                            </template>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <template v-if="!readOnly">
                <b-row>
                    <b-col cols="12">
                        <div class="py-4">
                            <hr>
                        </div>
                    </b-col>
                </b-row>

                <!-- 소속 유저 (접기/펼치기) -->
                <b-card no-body class="mb-3">
                    <template #header>
                        <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                            <h6 class="mb-0">
                                소속 유저
                                <b-badge variant="secondary" class="ml-1">{{ selected_company_user.length }}</b-badge>
                            </h6>
                            <div class="d-flex align-items-center">
                                <template v-if="showInternalUsers">
                                    <b-btn variant="primary" class="mr-1" size="sm"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="add_assessment_participant('in')"
                                    >
                                        {{ add_participant_progress || '평가 참여자 추가하기' }}
                                    </b-btn>
                                    <b-btn variant="danger" size="sm" class="mr-2"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="$refs['admin-assessment-company-users'].clearSelected()"
                                    >
                                        선택 초기화
                                    </b-btn>
                                </template>
                                <b-btn variant="outline-secondary" size="sm"
                                       @click="showInternalUsers = !showInternalUsers"
                                >
                                    {{ showInternalUsers ? '숨기기' : '보이기' }}
                                </b-btn>
                            </div>
                        </div>
                    </template>
                    <b-collapse :visible="showInternalUsers">
                        <b-table ref="admin-assessment-company-users"
                                 :items="selected_company_user"
                                 :fields="internalUserFields"
                                 sticky-header="300px"
                                 select-mode="multi"
                                 responsive="sm"
                                 empty-text="소속 유저가 없습니다."
                                 class="mb-0"
                                 show-empty
                                 selectable
                                 @row-selected="onSearchedUsersSelected"
                        >
                            <template #cell(selected)="{ rowSelected }">
                                <b-form-checkbox :checked="rowSelected" disabled />
                            </template>
                            <template #empty="scope">
                                <div class="text-center">
                                    <h6 class="mb-0">{{ scope.emptyText }}</h6>
                                </div>
                            </template>
                        </b-table>
                    </b-collapse>
                </b-card>

                <!-- 사용자 검색 (통합) -->
                <b-form @submit="searchUser">
                    <b-card no-body>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between">
                                <h6 class="mb-0">사용자 검색</h6>
                                <div class="text-right">
                                    <b-btn variant="primary"
                                           class="mr-1"
                                           size="sm"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           type="submit"
                                    >
                                        조회하기
                                    </b-btn>
                                    <b-btn variant="danger"
                                           size="sm"
                                           type="reset"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="initializeUserSearchForm"
                                    >
                                        초기화
                                    </b-btn>
                                </div>
                            </div>
                        </template>
                        <div class="py-3">
                            <div class="px-3">
                                <b-form-row>
                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-company_id"
                                            label="기업 ID"
                                            label-for="input-assessment-user-form-company_id"
                                        >
                                            <b-form-input id="input-assessment-user-form-company_id"
                                                          v-model="searchUserForm.company_id"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-company_name"
                                            label="기업명"
                                            label-for="input-assessment-user-form-company_name"
                                        >
                                            <b-form-input id="input-assessment-user-form-company_name"
                                                          v-model="searchUserForm.company_name"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-e_mail"
                                            label="이메일 (계정 ID)"
                                            label-for="input-assessment-user-form-e_mail"
                                        >
                                            <b-form-input id="input-assessment-user-form-e_mail"
                                                          v-model="searchUserForm.e_mail"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-user_name"
                                            label="이름"
                                            label-for="input-assessment-user-form-user_name"
                                        >
                                            <b-form-input id="input-assessment-user-form-user_name"
                                                          v-model="searchUserForm.user_name"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                            </div>
                            <template v-if="searchedUsers.length">
                                <div>
                                    <hr>
                                </div>
                                <div class="px-3">
                                    <b-card no-body>
                                        <template #header>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h6 class="mb-0">검색 결과</h6>
                                                <div class="text-right">
                                                    <b-btn variant="primary" class="mr-1" size="sm"
                                                           :disabled="is_disabled_global_managing_assessment_participant || !searchedUsers.length"
                                                           @click="add_assessment_participant('out')"
                                                    >
                                                        {{ add_participant_progress || '평가 참여자 추가하기' }}
                                                    </b-btn>
                                                    <b-btn variant="danger" size="sm"
                                                           :disabled="is_disabled_global_managing_assessment_participant || !searchedUsers.length"
                                                           @click="$refs['admin-assessment-searched-users'].clearSelected()"
                                                    >
                                                        선택 초기화
                                                    </b-btn>
                                                </div>
                                            </div>
                                        </template>

                                        <b-table ref="admin-assessment-searched-users"
                                                 :items="searchedUsers"
                                                 :fields="searchedUsersFields"
                                                 :busy="is_searching_users"
                                                 sticky-header="400px"
                                                 select-mode="multi"
                                                 responsive="sm"
                                                 empty-text="조회된 유저가 없습니다."
                                                 class="mb-0"
                                                 :selectable="!!searchedUsers.length"
                                                 show-empty
                                                 @row-selected="onSearchedUsersSelected"
                                        >
                                            <template #empty="scope">
                                                <div class="text-center">
                                                    <h6 class="mb-0">{{ scope.emptyText }}</h6>
                                                </div>
                                            </template>
                                        </b-table>
                                    </b-card>
                                </div>
                            </template>
                        </div>
                    </b-card>
                </b-form>
            </template>
        </b-modal>

        <b-modal ref="managing-request-access"
                 title="평가 관리 - 참여상태"
                 :no-close-on-backdrop="is_editing_request_access"
                 :no-close-on-esc="is_editing_request_access"
                 @hidden="initializeManagingAccess"
        >

            <b-form-group
                id="fieldset-managing-access-company"
                label="평가참여 기업"
                label-for="input-managing-access-company"
            >
                <b-form-input id="input-managing-access-company" v-model="editing_request_access.request_company_name" disabled />
            </b-form-group>

            <b-form-group
                id="fieldset-managing-access-email"
                label="사용자 계정"
                label-for="input-managing-access-email"
            >
                <b-form-input id="input-managing-access-email" v-model="editing_request_access.e_mail" disabled />
            </b-form-group>

            <b-form-group
                id="fieldset-managing-access-role"
                label="평가참여 역할"
                label-for="input-managing-access-role"
            >
                <b-form-select id="input-managing-access-role" v-model="editing_request_access.access_status" :options="request_access_options" />
            </b-form-group>

            <!-- {{ editing_request_access?.access_status }} -->

            <template #modal-footer>
                <div class="text-right">
                    <b-btn variant="primary" :disabled="is_editing_request_access || (typeof editing_request_access?.request_idx !== 'undefined' && company_request_member[editing_request_access.request_idx]['access_status'] == editing_request_access['access_status'])"
                           class="mr-1"
                           @click="updateAssessmentAccess"
                    >
                        저장하기
                    </b-btn>
                    <b-btn variant="danger"
                           :disabled="is_editing_request_access"
                           @click="$refs['managing-request-access'].hide()"
                    >
                        취소
                    </b-btn>
                </div>
            </template>
        </b-modal>
        <b-modal id="help-modal"
                 title="도움말"
        >
            <template>
                <div class="bg-light p-3">
                    <!-- 평가 참여자 추가 -->
                    <h5 class="fw-bold mb-3">평가 참여자 추가</h5>
                    <ul class="mb-4">
                        <li class="mb-2">
                            <span class="fw-semibold">외부 기업 사용자</span>
                            <ul>
                                <li>
                                    사용자 조회를 통해
                                    <span class="text-primary">현재 캠페인에 연결되지 않은 기업의 사용자</span>
                                    를 캠페인에 추가 가능.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span class="fw-semibold">내부 기업 사용자</span>
                            <ul>
                                <li>
                                    <span class="text-primary">현재 캠페인에 연결되어 있는 기업의 사용자</span>
                                    를 캠페인에 추가 가능.
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- 평가 참여자 관리 -->
                    <h5 class="fw-bold mb-3">평가 참여자 관리</h5>
                    <ul class="mb-4">
                        <li>평가 참여자를 최초로 추가하면 평가 참여자로 추가되고, 참여 상태가
                            <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[1]">
                                {{ request_access[1] }}
                            </b-badge></li>
                        <li>참여 상태, 역할 등을 변경할 수 있고, 평가 참여자 목록에서 제거 가능</li>
                    </ul>

                    <!-- 참고사항 -->
                    <h5 class="fw-bold mb-3">참고사항</h5>
                    <ul class="mb-2">
                        <li>평가 관리자는 <span class="fw-semibold">단 한 명만 존재</span> 가능</li>
                        <li>
                            권한 관리를 통해 평가 관리자 지정 시,
                            <ul>
                                <li>기존 관리자는 권한 박탈되고, 새로운 평가 관리자가 지정됨</li>
                            </ul>
                        </li>
                    </ul>
                    <div class="ms-3">
                        <div class="fw-semibold mb-1">참여 상태에 따른 권한 관리</div>
                        <ul>
                            <li>
                                <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[1]">
                                    {{ request_access[1] }}
                                </b-badge>, <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[2]">
                                {{ request_access[2] }}
                            </b-badge>
                                : 관리자 지정 불가</li>
                            <li><b-badge class="f-80 font-weight-normal" :variant="request_access_variant[0]">
                                {{ request_access[0] }}
                            </b-badge>: 평가 제외 불가</li>
                        </ul>
                    </div>
                </div>
            </template>


        </b-modal>
        <b-modal id="add-participant-mode-modal"
                 title="평가 참여자 추가 옵션"
                 centered
                 ok-title="추가"
                 cancel-title="취소"
                 @ok="executeAddParticipant"
        >
            <p class="mb-3">
                <strong>{{ selected_searched_users.length }}명</strong>의 사용자를 평가에 추가합니다.
            </p>
            <b-form-group label="참여 상태" class="mb-3">
                <b-form-radio-group v-model="addParticipantMode.approve" stacked>
                    <b-form-radio :value="false">승인 대기</b-form-radio>
                    <b-form-radio :value="true">바로 승인</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <b-form-group label="메일 발송" class="mb-0">
                <b-form-radio-group v-model="addParticipantMode.sendMail" stacked>
                    <b-form-radio :value="false">발송 안 함</b-form-radio>
                    <b-form-radio :value="true" disabled>
                        승인 메일 발송
                        <b-badge variant="secondary" class="ml-1">준비 중</b-badge>
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { companyRequestMemberColumn } from '@shared/components/admin/pages/Management/Company/data';

// 평가 참여자 API 오류 코드(평문 본문) -> 관리자용 문구
const MEMBER_ERROR_MESSAGES = {
    Not_Found_Campaign: '해당 기업과 관련없는 캠페인입니다.',
    Not_Found_Company: '존재하지 않는 기업입니다.',
    Not_Found_Request: '존재하지 않는 평가 신청 건입니다.',
    Not_Found_Users: '존재하지 않는 사용자입니다.',
    Not_Found_User: '존재하지 않는 사용자입니다.',
    Invalid_Request: '올바르지 않은 요청입니다.',
    Invalid_AccessStatus: '유효하지 않은 참여 상태입니다.',
    Not_Joined_User: '평가에 참여하지 않은 사용자입니다.',
    Not_Found_Manager: '기업 평가 관리자가 조회되지 않습니다.',
    UnAuthorized_Request: '관리자 변경을 요청할 권한이 없는 평가 참여자입니다.',
};
const getMemberErrorText = (error, fallback) => {
    const code = getErrorMessage(error, '');
    return MEMBER_ERROR_MESSAGES[code] || (code ? `${fallback} (${code})` : fallback);
};

// 평가 참여자 관리 모달. 부모가 ref 로 manageProjectMember(project) 를 호출해 연다.
// selected_company: { company_id, company_name, member: [...] }
// project: { request_id, project_code, campaign_id }
export default {
    name: 'AdminCompanyAssessmentMemberModal',
    components: {
        fa: FontAwesomeIcon
    },
    props: {
        selected_company: {
            type: Object,
            default: () => ({})
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showInternalUsers: false,

            // 기업 평가별 멤버 관리
            company_request_project_code: null,
            company_request_member: [],
            
            request_role: {
                1: '평가 참여자',
                2: '평가 관리자',
            },
            request_role_variant: {
                1: 'secondary',
                2: 'primary',
            },
            request_access: {
                0: '승인',
                1: '대기',
                2: '거부'
            },
            request_access_variant: {
                0: 'success',
                1: 'info',
                2: 'warning'
            },
            request_role_options: [
                { text: '대기중', value: 0 },
                { text: '참여자', value: 1 },
                { text: '관리자', value: 2 }
            ],

            request_access_options: [
                { text: '참여 승인', value: 0 },
                { text: '승인 대기중', value: 1 },
                { text: '참여 거부', value: 2 }
            ],

            // 평가 참여자 관리 모달 상태관리
            managing_assessment_info: null,
            is_opend_request_access_modal: false,

            //  ~ 참여상태 관련
            editing_request_access: {},
            is_editing_request_access: false,
            editing_request_access_user_id: null,

            //  ~ 평가 관리자 관련
            is_editing_request_role: false,
            editing_request_role_user_id: null,

            //  ~ 평가 참여자 추가 관련
            is_participating_assessment: false,
            participating_assessment_user_id: null,

            // 외부 평가자 조회 및 추가 관련
            //  ~ 외부 평가자 조회
            searchUserForm: {
                company_id: null,
                company_name: null,
                e_mail: null,
                user_name: null
            },
            is_searching_users: false,
            searchedUsersFields: [
                { key: 'company_id', label: '기업 ID'},
                { key: 'company_name', label: '기업명'},
                { key: 'user_id', label: '사용자 ID'},
                { key: 'e_mail', label: '이메일'},
                { key: 'user_name', label: '이름'}
            ],
            searchedUsers: [],
            selected_company_user: [],
            selected_searched_users: [],

            //  ~ 참여자 추가
            is_adding_participatent_searched_users: false,
            add_participant_progress: '',
            addParticipantMode: { approve: false, sendMail: false },
        };
    },
    computed: {
        internalUserFields() {
            return [
                { key: 'selected', label: '', thStyle: { width: '40px' }, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'user_id', label: '사용자 ID' },
                { key: 'e_mail', label: '이메일' },
                { key: 'user_name', label: '이름' },
            ];
        },
        companyRequestMemberColumn() {
            return companyRequestMemberColumn.map(column => ({
                ...column,
                label: this.$t(column.label),
            }));
        },
        is_disabled_searching_adding_searched_users () {
            return this.is_adding_participatent_searched_users || this.is_searching_users;
        },
        is_disabled_global_managing_assessment_participant () {
            return this.is_disabled_searching_adding_searched_users;
        },
        map_company_request_member(){
            const map = {};
            this.company_request_member.forEach(elem => {
                map[elem.user_id] = elem;
            });
            return map;
        }
    },
    watch: {
        company_request_member() {
            this.selected_company_user = this.selected_company_user.map(elem => {
                if(this.map_company_request_member[elem.user_id])
                    elem._rowVariant  = 'row-disabled-admin-company-assessment';
                else
                    delete elem._rowVariant;
                return elem;
            });
            this.sortInternalUsers();
            if(this.searchedUsers.length > 0){
                this.searchedUsers = this.searchedUsers.map(elem => {
                    if(this.map_company_request_member[elem.user_id])
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    else
                        delete elem._rowVariant;
                    return elem;
                });
            }
        },
        selected_company:{
            deep: true,
            handler(){
                this.selected_company_user = this.selected_company.member.map(elem => {
                    elem.company_name = this.selected_company.company_name;
                    if(this.map_company_request_member[elem.user_id]){
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    }
                    return elem;
                });
                this.sortInternalUsers();
            }
        }
    },
    created(){
        this.selected_company_user = this.selected_company.member.map(elem => {
            elem.company_name = this.selected_company.company_name;
            if(this.map_company_request_member[elem.user_id]){
                elem._rowVariant  = 'row-disabled-admin-company-assessment';
            }
            return elem;
        });
        this.sortInternalUsers();
    },
    methods: {
        openHelpModal(){
            this.$bvModal.show('help-modal');  
        },
        async searchUser (event) {
            event.preventDefault();
            try {
                this.is_searching_users = true;
                this.searchedUsers = [];
                const _searched_user = await this.$axios.get('/admin/users', {
                    params: {
                        company_id: this.searchUserForm.company_id,
                        company_name: this.searchUserForm.company_name,
                        e_mail: this.searchUserForm.e_mail,
                        user_name: this.searchUserForm.user_name,
                    }
                });

                this.searchedUsers = _searched_user.data.map(elem => {
                    if(this.map_company_request_member[elem.user_id]) {
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    }
                    return elem;
                });
            } catch (error) {
                alert('외부 기업 사용자 조회 도중 장애가 발생했습니다. 개발팀에 문의해주세요.');
            } finally {
                this.is_searching_users = false;
            }
        },
        initializeUserSearchForm () {
            this.searchUserForm = {
                company_id: null,
                company_name: null,
                e_mail: null,
                user_name: null
            };
        },
        onSearchedUsersSelected (_selected_searched_users, type){
            this.selected_searched_users = _selected_searched_users;
        },
        add_assessment_participant (type = 'out') {
            if(this.selected_searched_users.length === 0) {
                this.$EventBus.$emit('toast-failure', '참여자 추가', '사용자를 선택해주세요.');
                return;
            }
            this.addParticipantMode = { approve: false, sendMail: false };
            this.$bvModal.show('add-participant-mode-modal');
        },
        async executeAddParticipant() {
            const { approve, sendMail } = this.addParticipantMode;
            const users = this.selected_searched_users;
            const failures = [];
            const joined = [];
            const label = (user) => user.e_mail || user.user_name || user.user_id;

            try {
                this.is_adding_participatent_searched_users = true;

                for (const [idx, _searched_user] of users.entries()) {
                    this.add_participant_progress = `추가 중 (${idx + 1}/${users.length})`;
                    try {
                        await this.participateAssessment(_searched_user, {refresh: false});
                        joined.push(_searched_user);
                    } catch (error) {
                        failures.push(`${label(_searched_user)}: ${getMemberErrorText(error, '추가 실패')}`);
                    }
                }

                if (approve) {
                    for (const _searched_user of joined) {
                        try {
                            await this.$axios.post('/admin/assessment/member/approval', {
                                campaign_id: this.managing_assessment_info.campaign_id,
                                company_id: this.selected_company.company_id,
                                user_id: _searched_user.user_id,
                                status: 0
                            });
                        } catch (error) {
                            failures.push(`${label(_searched_user)}: 승인 실패 - ${getMemberErrorText(error, '승인 처리 실패')}`);
                        }
                    }
                }

                // 목록 갱신 (사용자마다가 아니라 마지막에 한 번)
                const _res = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });
                this.company_request_member = _res.data;

                if (failures.length > 0) {
                    this.$EventBus.$emit('toast-warning', '참여자 추가',
                        `${users.length}명 중 ${joined.length}명 추가, ${failures.length}건 실패했습니다. ${failures.join(' / ')}`);
                } else if (sendMail) {
                    // TODO: 메일 발송 API 연동
                    this.$EventBus.$emit('toast-success', '참여자 추가', `${joined.length}명 추가 완료. (메일 발송 기능은 준비 중입니다)`);
                } else {
                    const statusText = approve ? '승인' : '승인 대기';
                    this.$EventBus.$emit('toast-success', '참여자 추가', `${joined.length}명 추가 완료 (${statusText})`);
                }
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '참여자 추가', getMemberErrorText(error, '사용자 추가 도중 오류가 발생했습니다.'));
            } finally {
                this.is_adding_participatent_searched_users = false;
                this.add_participant_progress = '';
                if(this.$refs['admin-assessment-searched-users']){
                    this.$refs['admin-assessment-searched-users'].clearSelected();
                }
                if(this.$refs['admin-assessment-company-users']){
                    this.$refs['admin-assessment-company-users'].clearSelected();
                }
            }
        },
        sortInternalUsers() {
            this.selected_company_user.sort((a, b) => {
                const aDisabled = a._rowVariant ? 1 : 0;
                const bDisabled = b._rowVariant ? 1 : 0;
                return aDisabled - bDisabled;
            });
        },
        async manageProjectMember (project) {
            try {
                this.managing_assessment_info = project;
                const { request_id, project_code } = project;
                this.company_request_project_code = project_code;
                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id }
                });

                this.company_request_member = _res_company_request_member.data;

                this.$refs['modal-company-assessment-member'].show();
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '평가 참여자', getMemberErrorText(error, '평가 참여자 데이터를 불러오지 못했습니다.'));
            }
        },
        managingAccess (_request, _request_idx) {
            this.editing_request_access = {
                request_idx: _request_idx,
                ..._request
            };

            this.is_opend_request_access_modal = true;

            this.$nextTick(() => {
                this.$refs['managing-request-access'].show();
            });
        },
        async deleteAssessmentMember(_request, _request_idx){
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '평가 제외',
                message: `[${_request.e_mail || _request.user_name}] 님을 프로젝트 ${this.company_request_project_code} 평가에서 제외합니다. 참여 이력이 삭제되며 다시 참여시키려면 재추가가 필요합니다.`,
            });
            if (!confirmed) {
                return;
            }
            try {
                this.is_editing_request_access = true;
                this.editing_request_access_user_id = _request.user_id;
                const {user_id, request_id} = _request;
                await this.$axios.delete('/admin/assessment/member', {
                    params: { user_id, request_id }
                });

                this.company_request_member = this.company_request_member.reduce((acc, cur) => {
                    if (cur.user_id !== user_id) {
                        acc.push(cur);
                    }
                    return acc;
                },[]);

                this.$EventBus.$emit('toast-success', '평가 제외', '평가 참여자를 제외하였습니다.');
            }
            catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '평가 제외', getMemberErrorText(error, '평가 제외 처리 도중 오류가 발생했습니다.'));
            }
            finally {
                this.editing_request_access_user_id = null;
                this.is_editing_request_access = false;
            }
        },
        initializeManagingAccess () {
            this.editing_request_access = {};
            this.is_opend_request_access_modal = false;
        },
        // refresh=false 면 실패 시 throw (일괄 추가가 집계). 단건 버튼은 여기서 토스트로 알린다
        async participateAssessment (member, {refresh = true} = {}) {
            try {
                this.participating_assessment_user_id = member.user_id;
                this.is_participating_assessment = true;
                await this.$axios.post('/admin/assessment/member/join', {
                    campaign_id: this.managing_assessment_info.campaign_id,
                    company_id: this.selected_company.company_id,
                    user_id: member.user_id
                });

                if (refresh) {
                    const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                        params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                    });

                    this.company_request_member = _res_company_request_member.data;
                }
            } catch (error) {
                if (refresh) {
                    this.$EventBus.$emit('toast-failure', '평가 참여', getMemberErrorText(error, '평가 참여 처리 도중 오류가 발생했습니다.'));
                } else {
                    throw error;
                }
            } finally {
                this.is_participating_assessment = false;
                this.participating_assessment_user_id = null;
            }
        },
        initializeCompanyAssessmentMember () {
            this.managing_assessment_info = null;
        },
        async updateAssessmentAccess () {
            try {
                this.is_editing_request_access = true;
                const { campaign_id, request_company_id, user_id, access_status } = this.editing_request_access;
                this.editing_request_access_user_id = user_id;

                await this.$axios.post('/admin/assessment/member/approval', {
                    campaign_id, company_id: request_company_id, user_id, status: access_status
                });

                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });

                this.company_request_member = _res_company_request_member.data;

                this.$nextTick(() => {
                    this.$refs['managing-request-access'].hide();
                });
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '참여상태 변경', getMemberErrorText(error, '평가 참여상태 처리 도중 오류가 발생했습니다.'));
            } finally {
                this.editing_request_access_user_id = null;
                this.is_editing_request_access = false;
            }
        },
        async managingManagerRole (_request, _request_idx) {
            const current_manager = this.company_request_member.find(({ role }) => role === 2);
            if (!current_manager) {
                this.$EventBus.$emit('toast-failure', '관리자 지정', '관리자가 조회되지 않습니다.');
                return;
            }
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '관리자 지정',
                message: `[${_request.e_mail || _request.user_name}] 님을 평가 관리자로 지정합니다. 기존 관리자 [${current_manager.e_mail || current_manager.user_name}] 님은 관리자 권한을 잃습니다.`,
            });
            if (!confirmed) {
                return;
            }
            try {
                this.is_editing_request_role = true;
                this.editing_request_role_user_id = _request.user_id;

                await this.$axios.post('/admin/assessment/member/manager', {
                    current_manager_id: current_manager.user_id,
                    next_manager_id: _request.user_id,
                    company_id: _request.request_company_id,
                    campaign_id: _request.campaign_id
                });

                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });

                this.company_request_member = _res_company_request_member.data;
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '관리자 지정', getMemberErrorText(error, '관리자 변경 처리 도중 오류가 발생했습니다.'));
            } finally {
                this.is_editing_request_role = false;
                this.editing_request_role_user_id = null;
            }
        },
    }
};
</script>

<style lang="scss">
.table-row-disabled-admin-company-assessment {
    background-color: #f8f9fa !important;
    color: #adb5bd !important;
    pointer-events: none !important;
    td {
        background-color: #f8f9fa !important;
        color: #adb5bd !important;
        cursor: not-allowed;
    }
}
</style>
